import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPlaybooksEditDedicatedRoute: InvariantJiraRoute = {
	name: 'project-settings-playbooks-edit-dedicated',
	path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/edit/:playbookId',
	exact: true,
};
